<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">

        <el-container>
            <div width="360px">
                <div :class="$style.left">

                    <el-row>
                        <el-col :span="12">
                            <div style="padding-top: 8px;color: black;font-weight: bold;">门店管理</div>
                        </el-col>
                        <el-col :span="12">
                            <div align="right" v-show="isAdmin">
                                <el-button type="success" icon="el-icon-plus" size="small"
                                           @click.stop="addStore">
                                    新增门店
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>


                    <el-autocomplete
                            v-model="input"
                            placeholder="请输入门店名称进行快速搜索"
                            :fetch-suggestions="search"
                            @select="handleSelect"
                            :class="$style.search">

                    <span slot-scope="{ item }">
                        <span>{{item.store_name}}</span>
                    </span>

                    </el-autocomplete>

                    <div ref="scrollbar" style="border: 1px solid #dedede;margin-top: 5px;min-height: 500px" >
                        <el-tree
                                ref="menusTree"
                                :data="treeNodes"
                                :props="defaultProps"
                                :expand-on-click-node="false"
                                :auto-expand-parent="true"
                                node-key="id"
                                :default-expanded-keys="defaultExpandedKeys"
                                @node-expand="handleNodeExpand"
                                @node-click="handleNodeClick"
                        >
                    <span style="margin-top: 20px;margin-bottom: 20px" slot-scope="{ node, data }">
                        <span :class="['iconfont', 'icon-users', $style.first]" v-if="node.level === 1"></span>
                        <span :class="['iconfont', 'icon-users',$style.two]" v-else-if="node.level === 2"> </span>
                        <span :class="['iconfont', 'icon-users',$style.third]" v-else-if="node.level === 3"> </span>
                        <span :class="$style.font">{{node.label}}</span>
                    </span>
                        </el-tree>

                    </div>
                </div>
            </div>
            <el-main height="100%">
                <div :class="$style.right">

                    <div :class="$style.header">
                        <el-row>

                            <el-col :span="12">
                                <div align="left" style="padding-top: 8px; color: black;font-weight: bold;">{{companyName}}</div>
                            </el-col>
                            <el-col :span="12">
                                <div align="right">
                                    <el-button type="primary" size="small" @click.stop="saveStore()" v-show="showInfo">
                                        保存
                                    </el-button>
                                    <el-button icon="el-icon-plus" type="success" size="small" @click.stop="addClerk()" v-show="showAddClerk">
                                        添加店员
                                    </el-button>
                                    <el-button icon="el-icon-plus" type="success" size="small" @click.stop="saveShift()" v-show="showAddShift">
                                        添加班次
                                    </el-button>
                                    <el-button icon="el-icon-download" style="background-color: #FF9901;color: white;border: #FF9901" size="small" @click.stop="importTarget()" v-show="showImport">
                                        指标导入
                                    </el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </div>


                    <div :class="$style.body">
                        <!--<router-view></router-view>-->
                        <!--<el-scrollbar :class="$style.scrollbar" >-->
                        <router-view :key="key"></router-view>
                        <!--</el-scrollbar>-->
                    </div>
                </div>
            </el-main>
        </el-container>


        <div :class="$style.title">


        </div>
        <el-dialog
                :visible.sync="dialogVisible"
                width="35%"
                :show-close="false"
                :before-close="handleClose"

                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">

                <el-row>
                    <el-col :span="12">
                        <div style="color: #3998F7;font-weight: bold;padding-top: 8px;font-size: 16px">{{file_title}}
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button  type="primary" size="small" @click.stop="saveStore">
                                保存
                            </el-button>
                        </div>
                    </el-col>
                </el-row>


            </div>

        </el-dialog>

        <el-dialog :visible.sync="showStoreDialog" :show-close="false" width="80%">
            <div slot="title" :class="$style.title1">
                <span>新增门店</span>
                <div>
                    <el-button type="primary" size="small" @click.stop="handleSaveClick">保存</el-button>
                    <el-button type="danger" size="small" @click.stop="closeModal">取消</el-button>
                </div>
            </div>

            <SearchStoreItem/>
        </el-dialog>

    </div>

</template>


<script>
    // import TreeNode from './components/treeNode'
    import http from '../../APIService/http'
    import {bus} from '../../router/index.js'
    import ImgUrl_n_red from '../../assets/images/folder_icon.png'

    import StoresInfoPage from '../stores/storesInfo/index.vue'

    import SearchStoreItem from '../stores/storesInfo/searchStoreItem.vue'

    export default {
        data() {
            return {
                dialogVisible: false,
                showStoreDialog: false,
                loading: false,
                isAdmin: false,
                showInfo: false,
                showAddClerk: false,
                showAddShift: false,
                showImport: false,

                input: '',
                queryString: '',
                treeNodes: [],

                distributorInfo: [],
                storeInfo: [],
                defaultExpandedKeys: [],
                total: 0,

                companyName: '',

                file_title: '',
                icon_forder: ImgUrl_n_red,

                clientHeight: '',

                defaultProps: {
                    label: 'name',
                    children: 'children'
                },
            }
        },

        async created() {
            let userObj = this.$store.getters.getUser
            console.log(userObj)
            if(userObj.role === 'admin'){
                this.isAdmin = true
            }

            bus.$on('type', (text) => {

                let user = this.$store.getters.getUser
                if(text === 'info'){//基本信息
                    if(this.isAdmin){
                        this.showInfo = true
                    }
                    this.showAddClerk = false
                    this.showAddShift = false
                    this.showImport = false
                }else if(text === 'photo'){//照片
                    this.showInfo = false
                    this.showAddClerk = false
                    this.showAddShift = false
                    this.showImport = false

                }else if(text === 'clerk'){//店员列表
                    this.showInfo = false

                    if(user.isSalesDirector || !user.isManage || user.role === 'admin'){
                        this.showAddClerk = true
                    }

                    this.showAddShift = false
                    this.showImport = false
                }else if(text === 'shift'){//考勤班次
                    this.showInfo = false
                    this.showAddClerk = false
                    this.showImport = false

                    if(user.isSalesDirector || !user.isManage || user.role === 'admin'){
                        this.showAddShift = true
                    }

                }else if(text === 'sales'){//销售指标
                    this.showInfo = false
                    this.showAddClerk = false
                    this.showAddShift = false

                    if(user.isSalesDirector || !user.isManage || user.role === 'admin'){
                        this.showImport = true
                    }
                }else {
                    this.showInfo = false
                    this.showAddClerk = false
                    this.showAddShift = false
                    this.showImport = false
                }
            })


            this.initData(0,'','')
        },
        computed: {

            key() {
                return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
            }
        },
        components: {
            SearchStoreItem
        },
        methods: {
            addStore(){
                this.showStoreDialog = true

                bus.$emit('action_addStoreDialog', "")
            },
            closeModal(){
                this.showStoreDialog = false
            },
            handleSaveClick(){
                //新增门店详情
                bus.$emit('action_addStoreInfo', '')
            },

            async initData(level,id,parent_id ) {//获取大区
                this.loading = true
                try {
                    let data = {
                        id:id,
                        parent_id:parent_id,
                        level:level,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                    }
                    await http.post('/wapi/v1/getInitData', data).then(res => {


                        if(level === 0){
                            this.treeNodes = res.data
                            if(this.treeNodes.length > 0){

                                this.companyName = this.treeNodes[0].area

                                this.$store.commit('setStore', {
                                    region_id: this.treeNodes[0].region_id,
                                })


                                let storeObj = this.$store.getters.getStoreChange
                                if (storeObj.index) {
                                    storeObj.index = false

                                    this.$router.push({
                                        path: '/stores/area'
                                    })
                                } else {
                                    storeObj.index = true

                                    this.$router.push({
                                        path: '/stores/areaSecond'
                                    })
                                }

                            }

                        }else if(level === 1){
                            for(const index of this.treeNodes){

                                if(index.id === id){

                                    if(!(index.children.length > 0 && index.children[0] !== '')){
                                        index.children = res.data
                                    }
                                }
                            }
                        }else {
                            for(const index of this.treeNodes){


                                if(index.id === parent_id){
                                    for (const ind of index.children) {
                                        if(ind.id === id){

                                            if(!(ind.children.length > 0 && ind.children[0] !== '')){
                                                ind.children = res.data
                                            }
                                        }
                                    }
                                }

                            }
                        }


                        this.loading = false

                    })
                    //
                } catch (err) {
                    this.loading = false
                    console.log(`error:${err}`)
                }
            },

            saveStore() {
                //保存门店详情
                bus.$emit('action_saveStoreInfo', '')

            },

            addClerk() {
                //添加店员
                bus.$emit('action_addClerk', '')

            },
            saveShift() {
                //添加班次
                bus.$emit('action_addShift', '')

            },
            importTarget() {
                //导入指标
                bus.$emit('action_importTarget', '')

            },
            handleClose(done) {
//                this.$confirm('确认关闭？')
//                    .then(_ => {
                done();
//                    })
//                    .catch(_ => {});
            },


            async search(queryString, cb) {

                this.queryString = queryString.trim()
                if (queryString) {

                    try {

                        let data = {

                            tenant_id: this.$store.getters.getUser.tenant_id,
                            user_id: this.$store.getters.getUser.user_id,
                            search: queryString

                        }

                        await http.post('/wapi/v1/searchStoreData', data).then(res => {

                            cb(res.data);

                        })

                    } catch (err) {
                        console.log(`error:${err}`)
                    }

                } else {
                    // cp([])
                }
            },
            createStateFilter(queryString) {
                return (state) => {
                    return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            //过滤
            handleSelect(item) {
                this.input = this.queryString
                this.companyName = item.store_name

                this.$store.commit('setStore', {
                    id: item.store_id,
                    name: item.store_name
                })

                let storeObj = this.$store.getters.getStoreChange
                if (storeObj.index) {
                    storeObj.index = false

                    this.$router.push({
                        path: '/stores/index'
                    })
                } else {
                    storeObj.index = true

                    this.$router.push({
                        path: '/stores/indexSecond'
                    })
                }
            },


            // 节点被展开
            handleNodeExpand(data, node) {

                this.initData(node.level,data.id, node.parent.data.id)

            },
            // 节点被点击
            handleNodeClick(data, node) {

                if(node.level === 1){
                    this.companyName = data.area
                    bus.$emit('type', "")
                    this.$store.commit('setStore', {
                        region_id: data.region_id,
                    })

                    let storeObj = this.$store.getters.getStoreChange
                    if (storeObj.index) {
                        storeObj.index = false

                        this.$router.push({
                            path: '/stores/area'
                        })
                    } else {
                        storeObj.index = true

                        this.$router.push({
                            path: '/stores/areaSecond'
                        })
                    }


                }else if(node.level === 2){
                    this.companyName = data.city
                    bus.$emit('type', "")
                    this.$store.commit('setStore', {
                        city_id: data.city_id,
                        region_id: node.parent.data.region_id,
                    })

                    let storeObj = this.$store.getters.getStoreChange
                    if (storeObj.index) {
                        storeObj.index = false

                        this.$router.push({
                            path: '/stores/city'
                        })
                    } else {
                        storeObj.index = true

                        this.$router.push({
                            path: '/stores/citySecond'
                        })
                    }


                } else if(node.level === 3){
                    this.companyName = data.store_name

                    this.$store.commit('setStore', {
                        id: data.store_id,
                        name: data.store_name
                    })

                    let storeObj = this.$store.getters.getStoreChange
                    if (storeObj.index) {
                        storeObj.index = false

                        this.$router.push({
                            path: '/stores/index'
                        })
                    } else {
                        storeObj.index = true

                        this.$router.push({
                            path: '/stores/indexSecond'
                        })
                    }


                }

            },
            async refreshStore(rowObj) {
                if (rowObj.isEdit) {

                    // for (const ind of this.treeNodes) {
                    //     if (ind._id === rowObj.branchId) {//分公司
                    //         for (const item of ind.children) {
                    //             if (item._id === rowObj.dealerId) {//经销商
                    //                 for (const itemObj of item.children) {
                    //                     if (itemObj._id === rowObj.id) {
                    //
                    //                         itemObj.address = rowObj.address
                    //                         itemObj.status = rowObj.status
                    //
                    //                         if (itemObj.status === "INACTIVE") {
                    //                             itemObj.name = '(撤) ' + rowObj.name
                    //                         } else {
                    //                             itemObj.name = rowObj.name
                    //                         }
                    //
                    //
                    //                         break
                    //                     }
                    //                 }
                    //
                    //             }
                    //         }
                    //         let obj = this.$store.getters.getMyStore
                    //
                    //         if (obj.index) {
                    //             obj.index = false
                    //             this.$router.push({
                    //                 path: '/store/index1'
                    //             })
                    //         }
                    //         else {
                    //             obj.index = true
                    //             this.$router.push({
                    //                 path: '/store/index'
                    //             })
                    //         }
                    //     }
                    // }
                } else {//新增  刷新

                    // for (const ind of this.treeNodes) {
                    //     if (ind._id === rowObj.branchId) {//分公司
                    //         if (!ind.children) {
                    //             continue
                    //         }
                    //         for (const item of ind.children) {
                    //             if (item._id === rowObj.dealerId) {//经销商
                    //                 if (!item.children) {
                    //                     item.children = []
                    //                 }
                    //                 item.children.push({
                    //                     _id: rowObj.id,
                    //                     name: rowObj.name,
                    //                     address: rowObj.address,
                    //                     status: rowObj.status
                    //                 })
                    //
                    //                 let obj = this.$store.getters.getMyStore
                    //
                    //                 if (obj.index) {
                    //                     obj.index = false
                    //                     this.$router.push({
                    //                         path: '/store/index1'
                    //                     })
                    //                 }
                    //                 else {
                    //                     obj.index = true
                    //                     this.$router.push({
                    //                         path: '/store/index'
                    //                     })
                    //                 }
                    //                 break
                    //             }
                    //         }
                    //
                    //     }
                    // }

                }
            },
            // 获取点击的经销商信息
            getDistributorInfo(data, total) {

                this.distributorInfo = data
                this.total = total
            },
            // 获取点击的门店信息
            getStoreInfo(data) {

                this.storeInfo = data
            },
            getBrachInfo(data) {
                this.brachInfo = data
            }
        }
    }
</script>
<style lang="scss" module>
    .container {
        padding-top: 20px;
        padding-right: 20px;
        padding-left: 20px;
        padding-bottom: 20px;
        background: #fff;
        min-height: 90%;
        .title {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            > span {
                color: #3998f7;
                font-size: 16px;
            }
        }

        .title1 {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            border-bottom: 2px dotted #e7eaec;
            padding-bottom: 10px;
            > span {
                color: #3998f7;
                font-size: 16px;
            }
        }

        .left {
            font-size: 18px;
            .search {
                margin-top: 20px;
                width: 360px;

            }
            .type {
                em {
                    color: #d98f2f;
                    font-size: 14px;
                    font-weight: bold;
                }
            }

            .first {
                color: #7CA7DA;
                font-size: 20px;
            }
            .two {
                color: #7CDAAA;
                font-size: 20px;
            }
            .third {
                color: #FFC688;
                font-size: 20px;
            }
            .font {
                font-size: 14px;
                color: #555555;
            }
        }
        .right {
            font-size: 18px;
            margin-top: -20px;
            width: 100%;
            .header {
                width: 100%;
                height: 30px;
                padding-bottom: 10px;
                border-bottom: 2px dotted #e7eaec;

            }
            .body {

                margin-top: 10px;
                height: 100%;

            }
        }

        .noData {

        }
    }
</style>
<style scoped>
    .subjectList >>> .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
    }
</style>





// WEBPACK FOOTER //
// src/pages/stores/home.vue